function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { createContext, useEffect, useState } from 'react';
import { useOrg } from '../hooks/useOrg';
import { get } from '../lib/api';
export var Context = createContext(undefined);
export var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      user = _useState[0],
      setUser = _useState[1];

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId,
      apiHost = _useOrg.apiHost;

  function getSession() {
    return get(apiHost, '/api/user', {
      organizationId: organizationId
    });
  }

  useEffect(function () {
    getSession().then(function (_ref2) {
      var data = _ref2.data,
          error = _ref2.error;

      if (error) {
        console.error('ERROR', data.error);
      } else {
        var _data$profile;

        var role = (_data$profile = data.profile) === null || _data$profile === void 0 ? void 0 : _data$profile.role;
        var isModerator = role === 'admin' || role === 'moderator';
        setUser(_extends({}, data, {
          isModerator: isModerator
        }));
      }
    })["catch"](function (err) {
      console.log('error getting session', err);
    });
  }, [user === null || user === void 0 ? void 0 : user.id]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      user: user,
      setUser: setUser
    }
  }, children);
};